'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var smallDevice = exports.smallDevice = '@media (max-width: 769px)';
var largeDevice = exports.largeDevice = '@media (min-width: 770px)';


//////////////////
// WEBPACK FOOTER
// ./~/react-images/lib/components/css-helpers.js
// module id = 676
// module chunks = 0